// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3sUnp","row":"Node_row__3E17V","label":"Node_label__2QMSe","footer":"Node_footer__1Jkpt"};